// ICPAK SME / Group Medical — approved rates 2025
// Source: SINGLE RATES sheet, SME PRICING TOOL - 2025 -Unprotected.xlsm
//
// Rate tables: rates[limitIndex][configIndex]
// configIndex: 0=M, 1=M+1, 2=M+2, 3=M+3, 4=M+4, 5=M+5, 6=Additional Dependent
export const groupMedicalRatesData = {
    product: "group_medical",
    version: "2025.1",
    inpatient: {
        limits: [
            250000, 300000, 400000, 500000, 750000,
            1000000, 1500000, 2000000, 2500000, 3000000,
            4000000, 5000000, 7500000, 10000000,
        ],
        // [M, M+1, M+2, M+3, M+4, M+5, AdditionalDep]
        rates: [
            [23555, 36851, 52120, 62648, 69813, 75046, 10298], // 250k
            [25219, 39454, 55803, 67074, 74746, 80349, 11026], // 300k
            [27845, 43563, 61613, 74059, 82529, 88715, 12174], // 400k
            [29882, 46749, 66120, 79476, 88566, 95205, 13065], // 500k
            [32426, 50729, 71749, 86242, 96106, 103310, 14177], // 750k
            [34883, 54574, 77187, 92778, 103389, 111139, 15251], // 1M
            [38606, 60397, 85423, 102678, 114421, 122998, 16878], // 1.5M
            [41719, 65267, 92311, 110957, 123648, 132916, 18240], // 2M
            [42046, 65779, 93035, 111827, 124617, 133958, 18383], // 2.5M
            [42904, 67121, 94934, 114109, 127160, 136692, 18758], // 3M
            [49461, 77379, 109442, 131548, 146594, 157582, 21624], // 4M
            [52518, 82163, 116208, 139681, 155656, 167324, 22961], // 5M
            [72853, 113977, 161203, 193765, 215927, 232112, 31852], // 7.5M
            [74110, 115942, 163984, 197107, 219651, 236116, 32401], // 10M
        ],
    },
    outpatient: {
        limits: [
            30000, 50000, 75000, 80000, 100000, 150000, 200000,
            250000, 300000, 350000, 400000, 450000, 500000,
        ],
        rates: [
            [20089, 29123, 29123, 29123, 29123, 29123, 1807], // 30k
            [24420, 38203, 48450, 48450, 48450, 48450, 4824], // 50k
            [28832, 45106, 63796, 72810, 72810, 72810, 8796], // 75k
            [29398, 45992, 65049, 78189, 87132, 91018, 12324], // 80k
            [31356, 49055, 69382, 83396, 92934, 97080, 13145], // 100k
            [39078, 61137, 86469, 103935, 115823, 124505, 17085], // 150k
            [41904, 65557, 92721, 111450, 124197, 133506, 18320], // 200k
            [44095, 68985, 97570, 117278, 130692, 140488, 19279], // 250k
            [45886, 71787, 101532, 122041, 135999, 146193, 20061], // 300k
            [47400, 74155, 104882, 126067, 140486, 151016, 20723], // 350k
            [48711, 76207, 107783, 129555, 144372, 155194, 21297], // 400k
            [49868, 78016, 110343, 132631, 147801, 158880, 21802], // 450k
            [50903, 79635, 112632, 135383, 150867, 162176, 22255], // 500k
        ],
    },
    dental: {
        limits: [5000, 7500, 10000, 15000, 20000, 25000, 30000, 40000, 50000],
        rates: [
            [1116, 1563, 1786, 2009, 2232, 2456, 223], // 5k
            [1675, 2344, 2679, 3014, 3349, 3683, 335], // 7.5k
            [2778, 3888, 4444, 5000, 5555, 6110, 555], // 10k
            [4266, 5971, 6824, 7678, 8530, 9383, 853], // 15k
            [5720, 8007, 9150, 10295, 11439, 12582, 1144], // 20k
            [5582, 7813, 8929, 10047, 11162, 12278, 1116], // 25k
            [6698, 9376, 10715, 12056, 13395, 14734, 1339], // 30k
            [8931, 12501, 14287, 16074, 17860, 19645, 1786], // 40k
            [11164, 15627, 17858, 20093, 22324, 24556, 2232], // 50k
        ],
    },
    optical: {
        limits: [5000, 7500, 10000, 15000, 20000, 25000, 30000, 40000, 50000],
        rates: [
            [1180, 1652, 1888, 2124, 2360, 2596, 236], // 5k
            [1770, 2478, 2831, 3186, 3540, 3893, 354], // 7.5k
            [2936, 4109, 4696, 5284, 5871, 6457, 587], // 10k
            [4509, 6311, 7212, 8114, 9016, 9917, 901], // 15k
            [6046, 8463, 9672, 10882, 12091, 13299, 1209], // 20k
            [5900, 8259, 9438, 10619, 11799, 12978, 1180], // 25k
            [7080, 9911, 11326, 12743, 14158, 15573, 1416], // 30k
            [9440, 13214, 15101, 16991, 18878, 20765, 1888], // 40k
            [11801, 16518, 18876, 21239, 23597, 25956, 2360], // 50k
        ],
    },
    // Maternity: flat annual premium per family regardless of family configuration.
    maternity: {
        limits: [30000, 50000, 75000, 80000, 100000, 150000, 200000, 250000, 300000],
        premiums: [4927, 8212, 12317, 13138, 16423, 24634, 32846, 41058, 49269],
    },
    // Critical illness extension: rate % of sum insured by average age band.
    criticalIllness: {
        ratePctByAgeBand: {
            "21-30": 0.004,
            "31-40": 0.006,
            "41-50": 0.009,
            "51-60": 0.013,
        },
    },
    // Group Personal Accident extension: rate % of PA sum insured per life.
    groupPersonalAccident: { ratePct: 0.002 },
    // Training & Policy Holder Fund levy on net medical premium.
    levies: { trainingAndPolicyHolderFundPct: 0.0045 },
    // SMART virtual card fee per life (waived if alreadyOnSmart = true).
    smartFeePerLifeKes: 870,
    // Co-payment discount applied to total medical premium when coPayments = true.
    coPaymentDiscountPct: 0.10,
    stampDutyKes: 40,
};
